import { Stack } from '@mui/material';
import { FC } from 'react';
import { PeakEnergyCard } from '../PeakEnergyCard';
import EnergyDurationCard from '../EnergyDurationCard';
import { EnergyValueCardProps } from '../../../types';
import { PeakDipsGraph, PeakDipsValuesCard } from '../../../DataCircadianDashboard';
import { PeakDipStartEndSet } from '../../../../../data-access';
import './DataCircadianFullView.scss';
import SimpleCircadianChart from '../SimpleCircadianChart';
import { EnergyDataTrend } from '@demind-inc/core';

interface DataCircadianFullViewProps extends EnergyValueCardProps {
  energyDailyTrend: EnergyDataTrend;
  highEnergyDurationDiff: number;
  highEnergyDurationDiffColor: string;
  weeklyHighEnergyDuration?: number;
  weeklyHighEnergyDurationDiff?: number | null;
  weeklyHighEnergyDurationDiffColor?: string;
  targetPeakDipStartEndSet: PeakDipStartEndSet;
  basePeakDipStartEndSet: PeakDipStartEndSet;
  isWeekly: boolean;
  chartData: number[];
}

const DataCircadianFullView: FC<DataCircadianFullViewProps> = ({
  peakEnergy,
  dataTrendPeriod,
  diff,
  diffColor,
  energyDailyTrend,
  highEnergyDurationDiff,
  highEnergyDurationDiffColor,
  weeklyHighEnergyDuration,
  weeklyHighEnergyDurationDiff,
  weeklyHighEnergyDurationDiffColor,
  targetPeakDipStartEndSet,
  basePeakDipStartEndSet,
  isWeekly,
  chartData,
}) => {
  return (
    <Stack className="data-circadian-full-view">
      <Stack direction={'row'} flex={1} gap={1}>
        <Stack flex={1}>
          <PeakEnergyCard
            peakEnergy={peakEnergy}
            dataTrendPeriod={dataTrendPeriod}
            diff={diff}
            diffColor={diffColor}
          />
        </Stack>
        <EnergyDurationCard
          energyDailyTrend={energyDailyTrend}
          highEnergyDurationDiff={highEnergyDurationDiff}
          highEnergyDurationDiffColor={highEnergyDurationDiffColor}
          weeklyHighEnergyDuration={weeklyHighEnergyDuration}
          weeklyHighEnergyDurationDiff={weeklyHighEnergyDurationDiff}
          weeklyHighEnergyDurationDiffColor={weeklyHighEnergyDurationDiffColor}
        />
      </Stack>
      <Stack gap={1} mt={2}>
        {!isWeekly && (
          <div className="data-circadian-full-view__content-item">
            <PeakDipsValuesCard
              targetPeakDipStartEndSet={targetPeakDipStartEndSet}
              basePeakDipStartEndSet={basePeakDipStartEndSet}
              isWeekly={isWeekly}
              showTitle={false}
            />
          </div>
        )}
        <div className="data-circadian-full-view__content-item">
          {isWeekly ? (
            <PeakDipsGraph chartData={chartData.filter((item) => item)} />
          ) : (
            <SimpleCircadianChart />
          )}
        </div>
      </Stack>
    </Stack>
  );
};

export default DataCircadianFullView;
